import { render, staticRenderFns } from "./PersonsNavigation.vue?vue&type=template&id=485982b0&scoped=true&"
import script from "./PersonsNavigation.vue?vue&type=script&lang=js&"
export * from "./PersonsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PersonsNavigation.vue?vue&type=style&index=0&id=485982b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485982b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485982b0')) {
      api.createRecord('485982b0', component.options)
    } else {
      api.reload('485982b0', component.options)
    }
    module.hot.accept("./PersonsNavigation.vue?vue&type=template&id=485982b0&scoped=true&", function () {
      api.rerender('485982b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/persons/PersonsNavigation.vue"
export default component.exports